// src/components/social_login/MicrosoftLoginButton.tsx
import { createData } from "../../api/apiHelpers";
import { useSocialAuth } from "../../hooks/useAuth";
import { loginRequest, msalInstance } from "../../msalConfig";
import SocialLoginButton from "./SocialLoginButton";
import { useTranslation } from "../../i18n";
import logger from "utils/logger";

export default function MicrosoftLoginButton() {
  const { t } = useTranslation();
  const { handleSocialAuthSuccess, handleSocialAuthError } = useSocialAuth();

  const startLogin = async () => {
    try {
      logger.debug("🔹 Starting Microsoft loginPopup…");
      const result = await msalInstance.loginPopup(loginRequest);

      if (!result || !result.accessToken) {
        logger.error("❌ No accessToken from Microsoft");
        return;
      }

      const token = result.accessToken;
      const endpoint = "/auth/microsoft/login/";

      try {
        const data = await createData<{ access_token: string }, any>(endpoint, {
          access_token: token,
        });
        await handleSocialAuthSuccess(data);
      } catch (err: any) {
        const apiError = err.response?.data || {};
        await handleSocialAuthError("microsoft", token, err.response, apiError);
      }
    } catch (err) {
      logger.error("❌ Microsoft login failed:", err);
    }
  };

  return (
    <SocialLoginButton
      logoSrc="/microsoft_icon.png"
      alt="Microsoft"
      text={t("auth.sign_in_microsoft", "Sign in with Microsoft")}
      onClick={startLogin}
    />
  );
}
